<div class="fwc-flex a-center j-center uni-header">
    <img src="assets/images/test_university_logo.png" alt="" />
</div>
